export default {
  // Navbar
  search_placeholder: "ماذا تبحث عن؟",
  publish_ad: "نشر إعلان",
  sign_in: "تسجيل الدخول",
  logout: "تسجيل الخروج",
  profile: "ملفي الشخصي",
  my_ads: "إعلاناتي",
  admin: "لوحة الإدارة",
  messages: "الرسائل",
  home: "الرئيسية",
  member: "عضو",

  // Home
  categories_title: "الفئات الرئيسية",
  latest_ads: "أحدث الإعلانات",
  sell_cta_title: "هل لديك شيء للبيع؟",
  sell_cta_desc: "انشر إعلانك مجاناً وتواصل مع آلاف المشترين في الجزائر.",
  search_btn: "بحث",
  load_more: "عرض المزيد",
  loading: "جاري التحميل...",
  no_ads: "لا توجد إعلانات حالياً.",

  // Categories
  cat_cars: "سيارات",
  cat_realestate: "عقارات",
  cat_phones: "هواتف",
  cat_jobs: "وظائف",
  cat_bikes: "دراجات نارية",
  cat_electronics: "إلكترونيات",
  cat_vehicles: "مركبات",
  cat_furniture: "أثاث",
  cat_fashion: "موضة",
  cat_sports: "رياضة",
  cat_animals: "حيوانات",
  cat_services: "خدمات",
  all_categories: "كل الفئات",

  // Product card
  price_on_request: "السعر قابل للتفاوض",
  today: "اليوم",
  yesterday: "أمس",
  country: "الجزائر",
  currency: "دج",

  // Listing pages
  items_found: "مقال",
  search_direct: "البحث عن",
  showing: "عرض",
  of: "من",
  results: "نتائج",
  search_results_for: "نتائج البحث عن",

  // Footer
  footer_desc: "9achna — السوق الموثوق في الجزائر لشراء وبيع المنتجات المستعملة.",
  quick_links: "روابط سريعة",
  categories: "الفئات",
  contact_us: "اتصل بنا",
  about: "من نحن",
  help: "مركز المساعدة",
  privacy: "سياسة الخصوصية",
  terms: "شروط الاستخدام",
  made_with: "صُنع بـ",
  in_country: "في الجزائر",
  sell_items: "نشر إعلان",

  // Sell / SellForm
  sell_hero_title: "ابدأ البيع اليوم",
  sell_hero_desc: "تواصل مع آلاف المشترين وبع منتجاتك بسرعة",
  sell_free_label: "مجاناً",
  sell_what_selling: "ماذا تريد أن تبيع؟",
  sell_choose_category: "اختر فئة للبدء",
  sell_change_category: "اختر فئة أخرى",
  sell_feature_photos: "رفع سهل",
  sell_feature_photos_desc: "أضف صورك في ثوانٍ",
  sell_feature_fast: "بيع سريع",
  sell_feature_fast_desc: "تواصل مع المشترين فوراً",
  sell_feature_secure: "آمن",
  sell_feature_secure_desc: "معاملات آمنة وموثوقة",

  // SellForm
  post_ad_title: "نشر إعلانك",
  post_ad_submit: "نشر الإعلان",
  sell_change: "تغيير",
  photos_label: "الصور",
  add_photo: "إضافة صورة",
  photos_hint: "أضف صورتين واضحتين على الأقل (12 كحد أقصى). الصورة الأولى هي الصورة الرئيسية.",
  posting_ad: "جارٍ نشر الإعلان...",

  // Validation
  validation_error: "خطأ في التحقق",
  err_title_required: "يرجى إضافة عنوان",
  err_brand_required: "يرجى اختيار الماركة",
  err_title_short: "يجب أن يحتوي العنوان على 3 أحرف على الأقل",
  err_title_long: "يجب ألا يتجاوز العنوان 100 حرف",
  err_desc_required: "يرجى إضافة وصف",
  err_desc_short: "يجب أن يحتوي الوصف على 10 أحرف على الأقل",
  err_desc_long: "الوصف طويل جداً",
  err_location_required: "يرجى إضافة عنوان أو تحديد موقعك",
  err_image_required: "أضف صورتين على الأقل",
  err_image_max: "الحد الأقصى 12 صورة",
  err_name_required: "يرجى إضافة اسمك",
  err_price_required: "يرجى تحديد السعر",
  err_price_invalid: "يرجى إدخال سعر صالح",
  err_price_max: "لا يمكن أن يتجاوز السعر 100,000,000 دج",
  login_required: "تسجيل الدخول مطلوب",
  login_required_desc: "يجب أن تكون مسجلاً لنشر إعلان.",
  post_ad_error: "فشل النشر. يرجى المحاولة مجدداً.",
  error: "خطأ",

  // Price field
  price_label: "السعر",
  price_enter: "أدخل السعر",
  price_hint: "حدد سعراً تنافسياً للبيع بشكل أسرع.",

  // Details / Addetails (SellForm sub-components)
  ad_details: "تفاصيل الإعلان",
  ad_title: "عنوان الإعلان",
  ad_title_placeholder: "أدخل عنواناً جذاباً",
  ad_title_hint: "كن دقيقاً ووصفياً لجذب المشترين",
  ad_description: "الوصف",
  ad_desc_placeholder: "صف منتجك: الحالة، اللون، الحجم، أي عيوب...",
  ad_desc_hint: "أدرج التفاصيل المهمة للمشترين",
  your_details: "معلوماتك",
  your_name: "الاسم",
  phone_number: "رقم الهاتف",

  // SelectLocation
  loc_title: "الموقع",
  loc_select_tab: "اختر المدينة",
  loc_current_tab: "موقعك الحالي",
  loc_select_wilaya: "اختر الولاية",
  loc_select_commune: "اختر البلدية",
  loc_enter_area: "الحي / تفاصيل إضافية (اختياري)",
  loc_detecting: "جارٍ تحديد موقعك...",
  loc_wilaya_label: "الولاية",
  loc_commune_label: "البلدية",
  loc_area_label: "الحي",
  loc_postcode_label: "الرمز البريدي",

  // PreviewAd
  preview_available: "متاح",
  preview_seller_info: "معلومات البائع",
  preview_seller_label: "بائع",
  preview_chat_seller: "تواصل مع البائع",
  preview_remove_ad: "حذف الإعلان",
  preview_removing: "جارٍ الحذف...",
  preview_location: "الموقع",
  preview_safety_tips: "نصائح السلامة",
  preview_safety_tip1: "التقِ في مكان عام آمن",
  preview_safety_tip2: "تحقق من المنتج قبل الدفع",
  preview_safety_tip3: "لا تدفع مسبقاً",

  // Chat safety banner
  chat_safety_title: "نصائح الأمان",
  chat_safety_1: "لا تشارك أبداً معلوماتك الشخصية (هاتف، عنوان، حساب بنكي)",
  chat_safety_2: "لا تدفع مسبقاً — ادفع فقط عند الاستلام يداً بيد",
  chat_safety_3: "تقابل في مكان عام وآمن",
  chat_safety_4: "احذر من العروض التي تبدو جيدة جداً لتكون حقيقية",
  chat_safety_dismiss: "فهمت",
  preview_verified: "بائع موثوق",
  preview_secure_tx: "معاملة آمنة",
  preview_removed_title: "تم حذف الإعلان",
  preview_removed_desc: "تم حذف الإعلان بنجاح.",
  preview_remove_error: "حدث خطأ أثناء الحذف.",
  preview_photos: "صور",
  preview_description: "الوصف",
  days_ago: "أيام",

  // Condition (état)
  condition_label: "الحالة",
  condition_new_tag: "جديد مع بطاقة",
  condition_new_no_tag: "جديد بدون بطاقة",
  condition_very_good: "حالة ممتازة",
  condition_good: "حالة جيدة",
  condition_fair: "حالة مقبولة",
  condition_parts: "للقطع",

  // Color (couleur)
  color_label: "اللون",
  color_optional: "(اختياري)",

  // Delivery
  delivery_label: "التوصيل",
  delivery_available: "التوصيل متاح",
  delivery_not_available: "لا يوجد توصيل",
  delivery_switch: "تقديم خدمة التوصيل (اختياري)",

  // Last seen
  online_now: "متصل الآن",
  min_ago: "دق",
  hours_ago: "س",

  // Offer
  offer_btn: "تقديم عرض",
  offer_modal_title: "تقديم عرض",
  offer_price_label: "عرضك (دج)",
  offer_price_placeholder: "مثال: 5000",
  offer_message_label: "رسالة (اختياري)",
  offer_message_placeholder: "اوصف عرضك...",
  offer_send: "إرسال العرض",
  offer_sending: "جارٍ الإرسال...",
  offer_sent_title: "تم إرسال العرض!",
  offer_sent_desc: "سيتلقى البائع عرضك وسيتواصل معك.",
  offer_error: "تعذر إرسال العرض.",

  // NotFound
  not_found_title: "الصفحة غير موجودة",
  not_found_desc: "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
  back_home: "العودة للرئيسية",
  search_items: "تصفح الإعلانات",

  // Loading
  please_wait: "يرجى الانتظار...",

  // Myads
  myads_title: "إعلاناتي",
  myads_subtitle: "إدارة ومتابعة إعلاناتك النشطة",
  myads_listing: "إعلان",
  myads_listings: "إعلانات",
  myads_active: "نشط",
  myads_view: "عرض",
  myads_edit: "تعديل",
  myads_delete: "حذف",
  myads_deleted: "تم حذف الإعلان",
  myads_delete_error: "تعذر حذف الإعلان.",
  myads_load_more: "عرض المزيد",
  myads_empty_title: "ليس لديك إعلانات بعد",
  myads_empty_desc: "انشر إعلانك الأول وتواصل مع آلاف المشترين.",
  myads_publish: "نشر إعلان",
  nav_home: "الرئيسية",

  // EditAd
  edit_ad_title: "تعديل الإعلان",
  edit_save: "حفظ التغييرات",
  edit_saving: "جارٍ الحفظ...",
  edit_saved: "تم تحديث الإعلان بنجاح",
  edit_save_error: "تعذر تحديث الإعلان.",
  edit_cancel: "إلغاء",
  edit_photos: "الصور",
  edit_photos_hint: "اضغط × لحذف صورة · حد أقصى 12 صورة",
  edit_photos_add: "إضافة صور",
  edit_location_section: "الموقع",
  edit_location_change: "تغيير الموقع",
  edit_location_current: "الموقع الحالي",
  edit_owner_name: "اسم البائع",
  edit_brand: "العلامة التجارية",
  edit_size_label: "المقاس",
  edit_color_custom: "لون آخر (اكتب اللون)...",
  edit_min_image: "مطلوب صورتان على الأقل",
  edit_uploading: "جارٍ رفع الصور...",

  // EditAd / SellForm — حقول حسب الفئة
  field_select_placeholder: "اختر...",
  field_sport_type:  "نوع الرياضة",
  field_model:       "الطراز",
  field_capacity:    "السعة / التخزين",
  field_format:      "الصيغة",
  field_author:      "المؤلف / الفنان",
  field_year:        "السنة",
  field_material:    "المادة",
  field_dimensions:  "الأبعاد",

  // PreviewAd new
  preview_added: "أضيف",
  preview_show_more: "عرض المزيد",
  preview_show_less: "عرض أقل",

  // SearchNotFound
  search_no_results: "لا توجد نتائج",
  search_no_results_desc: "جرب كلمات مختلفة أو وسّع نطاق بحثك.",
  search_again_placeholder: "ابحث عن شيء آخر...",

  // Auth — Login / Register
  login_welcome: "مرحباً بعودتك!",
  register_title: "إنشاء حساب",
  login_subtitle: "سجل الدخول إلى حسابك",
  register_subtitle: "انضم لآلاف المشترين والبائعين",
  email_label: "البريد الإلكتروني",
  password_label: "كلمة المرور",
  forgot_password: "نسيت كلمة المرور؟",
  sign_in_btn: "تسجيل الدخول",
  full_name: "الاسم الكامل",
  confirm_password: "تأكيد كلمة المرور",
  create_account: "إنشاء حساب",
  no_account: "ليس لديك حساب؟",
  create_one: "إنشاء حساب",
  has_account: "لديك حساب بالفعل؟",
  or_email: "أو بالبريد الإلكتروني",
  email_not_found: "البريد الإلكتروني غير موجود",
  incorrect_password: "كلمة المرور غير صحيحة",
  user_exists: "يوجد حساب بهذا البريد الإلكتروني",
  signing_in: "جارٍ تسجيل الدخول...",
  creating_account_loading: "جارٍ الإنشاء...",
  account_created: "تم إنشاء الحساب!",
  account_created_desc: "يمكنك الآن تسجيل الدخول.",
  go_to_login: "الذهاب لتسجيل الدخول",
  passwords_no_match: "كلمتا المرور غير متطابقتين",
  password_too_short: "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل",
  otp_invalid: "يرجى إدخال الرمز المكون من 4 أرقام كاملاً",
  otp_sent: "تم إرسال الرمز",
  otp_sent_desc: "تم إرسال رمز التحقق إلى",
  forgot_password_title: "نسيت كلمة المرور",
  forgot_password_hint: "أدخل بريدك الإلكتروني وسنرسل لك رمز إعادة التعيين.",
  enter_otp: "إدخال الرمز",
  new_password: "كلمة المرور الجديدة",
  send_otp_btn: "إرسال الرمز",
  reset_password_btn: "إعادة تعيين",
  resend_otp: "إعادة إرسال الرمز",
  back_to_login: "العودة لتسجيل الدخول",
  back: "رجوع",
  password_reset_success: "تم إعادة تعيين كلمة المرور!",
  now_sign_in: "يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",

  // Chat
  chat_inbox: "الرسائل",
  chat_no_messages: "لا توجد رسائل",
  chat_no_messages_desc: "ابدأ محادثة لرؤية رسائلك هنا",
  chat_conversations: "محادثة",
  chat_type_message: "اكتب رسالة...",
  chat_delete: "حذف المحادثة",
  chat_see_product: "عرض المنتج",
  chat_deleted: "تم حذف المحادثة",
  chat_not_found: "المحادثة غير موجودة",
  chat_select: "رسائلك",
  chat_select_desc: "اختر محادثة من القائمة للبدء",
  chat_cannot_send: "لا يمكنك إرسال هذه الرسالة",

  // Category filters
  filter_filters: "التصفية",
  filter_sort: "ترتيب حسب",
  filter_sort_newest: "الأحدث",
  filter_sort_price_asc: "السعر: من الأقل",
  filter_sort_price_desc: "السعر: من الأعلى",
  filter_price: "السعر (دج)",
  filter_price_min: "الأدنى",
  filter_price_max: "الأقصى",
  filter_condition: "الحالة",
  filter_delivery: "التوصيل",
  filter_wilaya: "الولاية",
  filter_apply: "تطبيق",
  filter_reset: "إعادة تعيين",
  filter_reset_all: "مسح الفلاتر",
  filter_category: "الفئة",
  filter_subcategory: "الفئة الفرعية",
  filter_brand: "الماركة",
  filter_size: "المقاس",
  filter_color: "اللون",

  // Product status
  status_available: "متاح",
  status_reserved: "محجوز",
  status_sold: "مباع",
  status_sold_notice: "هذا المنتج تم بيعه مسبقاً.",
  reserve_btn: "طلب الحجز",
  reserve_cancel: "إلغاء الحجز",
  reserve_success: "تم الحجز !",
  reserve_success_desc: "تم إشعار البائع.",
  reserve_error: "تعذّر تنفيذ هذا الإجراء.",
  reserve_request_sent: "تم إرسال الطلب",
  reserve_request_sent_desc: "يجب على البائع الموافقة على طلبك.",
  reserve_request_cancelled: "تم إلغاء الطلب",
  reserve_request_cancel: "سحب طلبي",
  reserve_pending_buyer: "في انتظار موافقة البائع",
  reserve_pending_seller: "طلب حجز وارد",
  reserve_pending_other: "طلب حجز قيد المعالجة",
  reserve_approve: "قبول",
  reserve_reject: "رفض",
  reserve_approved: "تم تأكيد الحجز",
  reserve_rejected: "تم رفض الطلب",
  status_reserved_me: "محجوز لي ✓",
  mark_sold_btn: "تحديد كمباع",
  mark_available_btn: "إعادة الطرح للبيع",
  mark_sold_success: "تم تحديد المنتج كمباع",
  mark_available_success: "تمت إعادة المنتج للبيع",

  // Report message
  report_btn: "الإبلاغ",
  report_title: "الإبلاغ عن هذه الرسالة",
  report_reason_label: "سبب البلاغ",
  report_send: "إرسال البلاغ",
  report_sent: "تم إرسال البلاغ",
  report_sent_desc: "سيقوم فريقنا بمراجعة هذه الرسالة.",
  report_error: "تعذّر إرسال البلاغ.",

  // Profile page
  profile_my_profile: "ملفي الشخصي",
  profile_my_listings: "إعلاناتي",
  profile_listings_manage: "إدارة ومتابعة إعلاناتك",
  profile_edit_btn: "تعديل الملف",
  profile_account_active: "نشط",
  profile_member_since: "عضو منذ",
  profile_share: "مشاركة الملف",
  profile_username_label: "اسم المستخدم",
  profile_user_listings: "إعلانات",
  profile_items_listed: "إعلان منشور",
  profile_load_more: "عرض المزيد",

  // Auth — username
  username_label: "اسم المستخدم",
  username_placeholder: "مثال: ahmed_dz",
  username_hint: "أحرف وأرقام و _ فقط.",
  username_taken: "اسم المستخدم هذا مستخدم بالفعل",
  identifier_label: "البريد الإلكتروني أو اسم المستخدم",
  identifier_placeholder: "exemple@email.com أو اسم_المستخدم",

  // EditProfile page
  edit_profile_title: "تعديل الملف الشخصي",
  edit_profile_view: "عرض الملف",
  edit_profile_basic_info: "المعلومات الأساسية",
  edit_profile_contact_info: "معلومات الاتصال",
  edit_profile_picture: "صورة الملف الشخصي",
  edit_profile_full_name: "الاسم الكامل",
  edit_profile_email: "البريد الإلكتروني",
  edit_profile_phone: "رقم الهاتف",
  edit_profile_save: "حفظ",
  edit_profile_cancel: "إلغاء",
  edit_profile_saving: "جارٍ الحفظ...",
  edit_profile_verified: "موثّق",
  edit_profile_not_verified: "غير موثّق",
  edit_verify_title: "تحقق من بريدك الإلكتروني",
  edit_verify_enter_code: "إدخال الرمز",
  edit_verify_subtitle: "أمّن حسابك بالتحقق",
  edit_verify_code_sent: "تم إرسال الرمز إلى بريدك",
  edit_verify_send_btn: "إرسال رمز التحقق",
  edit_verify_sending: "جارٍ الإرسال...",
  edit_verify_code_label: "رمز مكون من 4 أرقام",
  edit_verify_verifying: "جارٍ التحقق...",
  edit_verify_resend: "إعادة الإرسال",
  edit_verify_no_code: "لم تستلم الرمز؟",
  edit_verify_change_email: "تغيير البريد",

  // AdSuccess page
  adsuccess_title: "تم نشر إعلانك!",
  adsuccess_subtitle: "سيظهر إعلانك قريباً للمشترين.",
  adsuccess_step1: "يمكن للمشترين الآن العثور على منتجك.",
  adsuccess_step2: "أجب على الرسائل بسرعة لتبيع أسرع.",
  adsuccess_step3: "اتفق على مكان آمن لإتمام الصفقة.",
  adsuccess_view_ads: "عرض إعلاناتي",
  adsuccess_post_another: "نشر إعلان آخر",
  adsuccess_share: "مشاركة 9achna",

  // ── كيف يعمل ─────────────────────────────────────────────
  hiw_badge:            "9achna — دليل شامل",
  hiw_hero_title:       "كيف يعمل؟",
  hiw_hero_subtitle:    "الشراء والبيع على 9achna سهل وسريع ومجاني. إليك كل ما تحتاج معرفته.",
  hiw_start_sell:       "ابدأ البيع",
  hiw_browse:           "تصفح المقالات",
  hiw_see_articles:     "عرض المقالات",

  hiw_sell_label:       "هل تريد البيع؟",
  hiw_sell_title:       "4 خطوات للبيع",
  hiw_sell_subtitle:    "من الصورة إلى القبض — كل ذلك في دقائق.",

  hiw_sell_s1_title:    "التقط صورة",
  hiw_sell_s1_desc:     "صوّر منتجك بهاتفك. لا حاجة لاستوديو — إضاءة طبيعية جيدة كافية. صور متعددة تزيد فرص البيع.",
  hiw_sell_s1_tip:      "💡 نصيحة: صوّر على خلفية بيضاء أو محايدة",
  hiw_sell_s2_title:    "انشر في دقيقتين",
  hiw_sell_s2_desc:     "اختر الفئة، أدخل العنوان والمقاس والحالة والسعر. إعلانك يظهر فوراً لآلاف المشترين في الجزائر.",
  hiw_sell_s2_tip:      "💡 نصيحة: عنوان دقيق يجذب نقرات أكثر",
  hiw_sell_s3_title:    "تحدث مع المشتري",
  hiw_sell_s3_desc:     "المشترون المهتمون يتواصلون معك مباشرة عبر الرسائل. رد بسرعة لتعظيم مبيعاتك. يمكنك التفاوض على السعر مباشرة.",
  hiw_sell_s3_tip:      "💡 نصيحة: الرد خلال ساعة يضاعف المبيعات ثلاث مرات",
  hiw_sell_s4_title:    "بِع واستلم المال",
  hiw_sell_s4_desc:     "رتب التسليم في مكان عام، أو اقترح التوصيل. بمجرد إتمام الصفقة، البيع مكتمل!",
  hiw_sell_s4_tip:      "💡 نصيحة: فضّل الأماكن العامة للأمان",

  hiw_buy_label:        "هل تريد الشراء؟",
  hiw_buy_title:        "اعثر على الفرصة النادرة",
  hiw_buy_subtitle:     "آلاف المقالات بأسعار منخفضة، في كل أنحاء الجزائر.",

  hiw_buy_s1_title:     "ابحث عن المقال",
  hiw_buy_s1_desc:      "تصفح الفئات أو استخدم شريط البحث. فلتر حسب المقاس والحالة والسعر والولاية لتجد بالضبط ما تبحث عنه.",
  hiw_buy_s2_title:     "أضف إلى المفضلة",
  hiw_buy_s2_desc:      "احفظ المقالات التي تهمك في مفضلتك لإيجادها بسهولة ومقارنتها قبل الشراء.",
  hiw_buy_s3_title:     "تواصل مع البائع",
  hiw_buy_s3_desc:      "اضغط على 'تواصل مع البائع' لإرسال رسالة. اطرح أسئلتك وتفاوض على السعر ورتب اللقاء.",
  hiw_buy_s4_title:     "استلم مقالك",
  hiw_buy_s4_desc:      "التقِ بالبائع مباشرة أو استلم المقال عبر التوصيل. تحقق من المقال قبل الدفع.",

  hiw_tips_title:       "نصائح وممارسات جيدة",
  hiw_tips_subtitle:    "لتجربة آمنة وممتعة على 9achna.",

  hiw_tip1_title:       "السلامة أولاً",
  hiw_tip1_p1:          "التقِ دائماً في مكان عام (مقهى، مركز تجاري)",
  hiw_tip1_p2:          "تحقق من المقال قبل الدفع",
  hiw_tip1_p3:          "لا تشارك أبداً بياناتك المصرفية",
  hiw_tip1_p4:          "أبلغ عن أي سلوك مشبوه",

  hiw_tip2_title:       "التوصيل",
  hiw_tip2_p1:          "متاح عبر خدمات التوصيل الجزائرية",
  hiw_tip2_p2:          "تفاوض على من يتحمل رسوم التوصيل",
  hiw_tip2_p3:          "صوّر التغليف قبل الإرسال",
  hiw_tip2_p4:          "استخدم تتبع الطرد إن أمكن",

  hiw_tip3_title:       "نصائح البيع",
  hiw_tip3_p1:          "صور واضحة = مبيعات أكثر",
  hiw_tip3_p2:          "سعر عادل = بيع أسرع",
  hiw_tip3_p3:          "صف حالة المقال بصدق",
  hiw_tip3_p4:          "رد على الرسائل بسرعة",

  hiw_faq_title:        "الأسئلة الشائعة",
  hiw_faq_q1:           "هل هو مجاني؟",
  hiw_faq_a1:           "نعم، نشر الإعلان على 9achna مجاني 100%. لا عمولة ولا اشتراك.",
  hiw_faq_q2:           "كيف أحدد السعر المناسب؟",
  hiw_faq_a2:           "ابحث عن مقالات مماثلة على 9achna لتكوين فكرة. عموماً تُباع الملابس المستعملة بين 30% و60% من سعرها الجديد حسب الحالة.",
  hiw_faq_q3:           "كيف يتم التوصيل؟",
  hiw_faq_a3:           "يُنظَّم التوصيل مباشرة بين البائع والمشتري عبر خدمات التوصيل الجزائرية (Yalidine، Zaki...). الرسوم تُتفاوض بين الطرفين.",
  hiw_faq_q4:           "ماذا أفعل إذا واجهت مشكلة؟",
  hiw_faq_a4:           "استخدم زر 'الإبلاغ' على الإعلان أو تواصل معنا عبر صفحة الاتصال. فريقنا يعالج البلاغات بسرعة.",
  hiw_faq_q5:           "هل يمكنني البيع من أي ولاية؟",
  hiw_faq_a5:           "نعم! يغطي 9achna جميع الولايات الـ 58 في الجزائر. إعلانك مرئي لجميع المشترين في البلاد.",

  hiw_cta_title:        "مستعد للانطلاق؟",
  hiw_cta_subtitle:     "انضم إلى مجتمع 9achna وأعطِ ملابسك حياة ثانية.",
  hiw_sell_now:         "بِع الآن",

  // ── Hero Home ─────────────────────────────────────────────
  hero_badge:         "بيع وشراء الملابس المستعملة",
  hero_title_line1:   "اشتري وبع",
  hero_title_line2:   "ملابسك في الجزائر",
  hero_subtitle:      "خزانة بين الأفراد — نساء، رجال، أطفال.",
  hero_subtitle_bold: "في كل أنحاء الجزائر.",
  hero_cta_sell:      "ابدأ البيع",
  hero_cta_how:       "اكتشف كيف يعمل ←",
  hero_trust_free:    "مجاني",
  hero_trust_delivery:"توصيل",
  hero_trust_secure:  "آمن",

  // ── SEO keywords arabes (utilisés dans meta keywords) ─────
  seo_keywords_home: "ملابس مستعملة الجزائر، بيع ملابس بالدور الجزائر، فيستاد الجزائر، ملابس بنات مستعملة، ملابس أطفال مستعملة، فساتين سهرة مستعملة الجزائر، سوق الملابس المستعملة الجزائر، شراء وبيع ملابس بين أفراد، ملابس رخيصة الجزائر، بيع ملابس اون لاين الجزائر، ملابس مستعملة بأسعار رخيصة، كيفاش تبيع حوايجك في الجزائر",

  // ── Textes SEO pages catégories en arabe ──────────────────
  seo_femmes_title:    "ملابس نسائية مستعملة في الجزائر — شراء وبيع بين أفراد",
  seo_femmes_desc:     "اشتري وبيعي ملابس نسائية مستعملة في الجزائر على 9achna. فساتين، بنطلونات، قمصان، ملابس بالدور... مجاناً بين أفراد.",
  seo_hommes_title:    "ملابس رجالية مستعملة في الجزائر",
  seo_enfants_title:   "ملابس أطفال وبيبي مستعملة في الجزائر — بين أمهات",
  seo_mariage_title:   "فساتين أعراس وسهرات مستعملة في الجزائر",

  // ── Blog article Vinted ────────────────────────────────────
  blog_vinted_title:  "فينتاد الجزائر: 9achna هو البديل المحلي الحقيقي",
  blog_vinted_desc:   "فينتاد غير متوفر في الجزائر. اكتشف 9achna، البديل الجزائري لبيع وشراء الملابس المستعملة بين أفراد.",

  // الشراء والحجز
  buy_btn: "شراء",
  buy_intent_message: "مرحبًا، أرغب في شراء هذا المنتج. هل ما زال متوفرًا؟",
  reserve_for_buyer: "احجز لهذا المشتري",
  reserve_for_buyer_done: "تم حجز المنتج لهذا المشتري",
  show: "إظهار",
  hide: "إخفاء",
};
